<template>
    <v-container>
        <div style="background-color: rgb(230, 233, 242); padding-left: 20px; padding-right: 20px; padding-bottom: 15px; text-align: justify;">
            <h2 style="font-size: 2.5rem; color: rgb(0, 30, 67)">Créditos y agradecimientos</h2>
            <b>Segunda versión de IDmaderas</b><br><br>
            <p>
              La actualización de <b style="color: rgb(0, 30, 67)">IDmaderas</b>, que incorpora nuevas especies, mejora la experiencia del usuario e incluye una versión web, 
              ha sido posible gracias al Proyecto ECOS - Cooperación Regional para Enfrentar los Delitos Ambientales. Este esfuerzo es una iniciativa conjunta de la Agencia 
              de los Estados Unidos para el Desarrollo Internacional (USAID) y el Equipo Ambiental de la Oficina de las Naciones Unidas contra la Droga y el Delito (UNODC), 
              con el apoyo técnico del Centro de Innovación Tecnológico de la Madera (CITEmadera), perteneciente al Instituto Tecnológico de la Producción (ITP) del Ministerio de la Producción. <br><br>

              Agradecemos especialmente el aporte técnico y valioso de las siguientes instituciones, que ha sido fundamental para el éxito de esta actualización: Red CITEforestal del ITP, 
              Servicio Nacional Forestal y de Fauna Silvestre (SERFOR), Organismo de Supervisión de los Recursos Forestales y de Fauna Silvestre (OSINFOR) y la Cooperación Alemana para el Desarrollo (GIZ). <br><br>
              
              <div style="text-align: center;">
                <img src="../assets/creditos2.png" alt="Créditos y agradecimientos" style="width: 850px; max-width: 100%; height: auto;">
              </div>
            </p>
            <br>
            <b>Primera  versión de IDmaderas</b><br><br>
            <p>
              La primera versión de <b style="color: rgb(0, 30, 67)">IDmaderas</b> fue desarrollada en 2020, en el marco de la primera fase del Proyecto Respuestas de la Justicia Penal a 
              los Delitos Forestales en Perú, un esfuerzo conjunto entre el Equipo Ambiental de UNODC y el Ministerio Federal de Cooperación Económica y Desarrollo de Alemania (BMZ). Agradecemos 
              especialmente el valioso apoyo técnico del Laboratorio de Anatomía e Identificación de Maderas de la Universidad Nacional Agraria La Molina (UNALM), el CITEmadera y el Equipo Forense 
              en Materia Ambiental (EFOMA) del Ministerio Público del Perú. <br><br>              
              <div style="text-align: center;">
                <img src="../assets/creditos1.png" alt="Créditos y agradecimientos" style="width: 650px; max-width: 100%; height: auto;">
              </div>
            </p>
        </div>
    </v-container>
  </template>
    
    <script>
      export default {
        name: 'HelloWorld',
    
        data: () => ({
          
        }),
      }
    </script>
    <style>
        p {
          font-family: 'Heebo', sans-serif !important;
            font-size: 17px;        
            line-height: 1.6em;
        }
        h1 {
          font-family: 'Heebo', sans-serif !important;
            font-size: 2.5rem;
        }
        h2 {
          font-family: 'Sofia Sans', sans-serif !important;
        }
        h3 {
          font-family: 'Sofia Sans', sans-serif !important;
        }
        h5 {
            font-family: 'Sofia Sans', sans-serif !important;
            font-size: 1.25rem;
        }
        
    </style>